// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"TableFormEligibility__formWrapper___21tf1","tableWrapper":"TableFormEligibility__tableWrapper___PN9Dv","hidden":"TableFormEligibility__hidden___3Mhgh"};